import { Component, EventEmitter, Output, Input } from '@angular/core';
import { Common } from '../../shared/common';

@Component({
  selector: 'voters-relaunch-popup',
  templateUrl: './voters-relaunch-popup.component.html',
  styleUrls: ['./voters-relaunch-popup.component.less', '../../shared/common.less']
})
export class VotersRelaunchPopupComponent {
  @Output() isClosed = new EventEmitter<boolean>();
  @Input() isResend = true;
  @Input() isAssessors = false;

  onDismiss(event: boolean) {
    this.isClosed.emit(event);
  }
  constructor(public common: Common) { }

}
